import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

export default function CompletionCheckMark({ size = "sm", className = "", label = "Section filled out" }) {
  return (
    <span className={`text-success ${className}`.trim()} role="img" aria-label={label}>
      <FontAwesomeIcon icon={faCheckCircle} size={size} aria-hidden="true" />
    </span>
  );
}

CompletionCheckMark.propTypes = {
  size: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
};
